import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { DefaultResponseInterface } from '../model/response/default-response.interface';

@Injectable()
export class AdminRegistrationGroupsApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchList(regID) {
    return this.http.get<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/registration/${regID}/user-groups`,
      {headers: this.getAuthHeaders()}
    );
  }

  public create(regID, body: {groups: string}) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/registration/${regID}/user-groups`,
      body,
      {headers: this.getAuthHeaders()}
    );
  }
}
